import { useParams } from 'react-router-dom';
import { Table, TableBody } from '@mui/material';
import { Row, SectionWrapper } from '../../../components/tableComponents';

type props = {
    height: string
  }
  
const TxOverview = ({height}: props) => {
    const { txHash } = useParams();
    return (
      <>
        <h4>Overview:</h4>
        <SectionWrapper>
          <Table  aria-label="overview snapshot table">
              <TableBody>
                  <Row field='Hash' value={txHash!} hasCopyOption route={`/tx/${txHash}`} />
                  <Row field='Block height' hasCopyOption route={`/block/${height}`} value={height}/>
              </TableBody>
          </Table>
        </SectionWrapper>
      </>
    )
}

export default TxOverview;
  